/* eslint-disable no-restricted-imports -- file defines overrides */
import {
  ContextSheet as BricksContextSheet,
  FullScreenModal as BricksFullScreenModal,
  Modal as BricksModal,
  Popover as BricksPopover,
} from '@opendoor/bricks/complex/Modal';

import { withClientOnly } from 'platform/remix-run/utils/client-only';

/** @deprecated This component uses Bricks styles. Please consult your design and migrate this usage to bricks-next */
export const Modal = withClientOnly(BricksModal);
/** @deprecated This component uses Bricks styles. Please consult your design and migrate this usage to bricks-next */
export const Popover = withClientOnly(BricksPopover);
/** @deprecated This component uses Bricks styles. Please consult your design and migrate this usage to bricks-next */
export const ContextSheet = withClientOnly(BricksContextSheet);
/** @deprecated This component uses Bricks styles. Please consult your design and migrate this usage to bricks-next */
export const FullScreenModal = withClientOnly(BricksFullScreenModal);
